import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
} from '@mui/material';

const About: React.FC = () => {
  return (
    <Box id="about" sx={{ py: { xs: 6, md: 12 }, backgroundColor: 'background.default' }}>
      <Container maxWidth="lg">
        <Typography
          variant="h2"
          align="center"
          sx={{
            mb: 6,
            fontWeight: 600,
            fontSize: { xs: '2rem', md: '2.5rem' },
          }}
        >
          About Us
        </Typography>
        <Grid container spacing={6}>
          <Grid item xs={12} md={6}>
            <Typography
              variant="body1"
              sx={{
                mb: 3,
                fontSize: '1.1rem',
                lineHeight: 1.8,
              }}
            >
            {/*Abarcar Group is an Australian-based professional services firm specialising in integrated accounting, taxation, legal, and migration solutions.*/}
            Abarcar Group is an Australian-based professional services firm specialising in integrated accounting and taxation solutions.
                With a client-focused approach and a strong commitment to excellence, we deliver comprehensive advisory services tailored to
              individuals, businesses, and multinational organisations.
            </Typography>
            <Typography
              variant="body1"
              sx={{
                mb: 3,
                fontSize: '1.1rem',
                lineHeight: 1.8,
              }}
            >
                {/*Our team of professionals delivers tailored accounting solutions, optimises tax strategies, and provides expert guidance on complex legal and migration requirements.*/}
                Our team of professionals delivers tailored accounting solutions and optimises tax strategies.
                From supporting cross-border corporate expansion and ensuring regulatory compliance to assisting with Australian residency
              and citizenship, Abarcar Group offers innovative, strategic solutions that empower our clients to succeed.
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: '1.1rem',
                lineHeight: 1.8,
              }}
            >
              We take pride in our integrity, professionalism, and personalised service that make Abarcar
              Group a trusted partner for those seeking reliable, forward-thinking expertise in an evolving
              global landscape.
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src="/images/about-us.jpg"
              alt="About Abarcar Group"
              sx={{
                width: '100%',
                height: 'auto',
                borderRadius: 2,
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
              }}
            />
          </Grid>
        </Grid>



      </Container>
    </Box>
  );
};

export default About; 